module.exports = __webpack_public_path__ + "img/logo2.14f0b96d.png";